import { render, staticRenderFns } from "./SlideType.vue?vue&type=template&id=08e323be&scoped=true&"
import script from "./SlideType.vue?vue&type=script&lang=js&"
export * from "./SlideType.vue?vue&type=script&lang=js&"
import style0 from "./SlideType.vue?vue&type=style&index=0&id=08e323be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e323be",
  null
  
)

export default component.exports